export default  {"src":"/_next/static/image/public/assets/icons/info-icon.f1e29d1d9405a6282ff2eb094c7aa1be.svg","height":16,"width":16};